"use strict";

exports.__esModule = true;
exports["default"] = exports.addPresetStyles = void 0;

var _layout = _interopRequireDefault(require("../../../common/constants/layout"));

var _alternateGallery = require("./alternateGallery");

var _bricksGallery = require("./bricksGallery");

var _collageGallery = require("./collageGallery");

var _fullsizeGallery = require("./fullsizeGallery");

var _columnGallery = require("./columnGallery");

var _gridGallery = require("./gridGallery");

var _magicGallery = require("./magicGallery");

var _masonryGallery = require("./masonryGallery");

var _mixGallery = require("./mixGallery");

var _panoramaGallery = require("./panoramaGallery");

var _sliderGallery = require("./sliderGallery");

var _slideshowGallery = require("./slideshowGallery");

var _thumbnailGallery = require("./thumbnailGallery");

var _emptyGallery = require("./emptyGallery");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addPresetStyles = function addPresetStyles(styles) {
  var galleryType = styles.galleryType;
  var galleryLayoutV1 = styles.galleryType;
  var galleryLayoutV2 = styles.galleryLayout;

  if (galleryLayoutV1 !== undefined && galleryLayoutV2 === undefined) {
    //legacy layouts - only if galleyrType parameter is specifically defined (i.e. layout had changed)
    switch (galleryType) {
      case '1':
        //horizontal collage
        return (0, _collageGallery.createStyles)(styles);

      case '2':
        //grid
        return (0, _gridGallery.createStyles)(styles);

      case '3':
        //vertical masonry
        return (0, _masonryGallery.createStyles)(styles);

      case '4':
        //horizontal masonry
        return (0, _masonryGallery.createStyles)(styles);

      case '5':
        //one column
        return (0, _panoramaGallery.createStyles)(styles);

      case '6':
        //one row
        return (0, _columnGallery.createStyles)(styles);

      case '7':
        //slideshow
        return (0, _slideshowGallery.createStyles)(styles);

      case '0': //vertical collage

      default:
        return (0, _collageGallery.createStyles)(styles);
    }
  } else {
    //new layouts
    switch (styles.galleryLayout) {
      case _layout["default"].MASONRY:
        return (0, _masonryGallery.createStyles)(styles);

      case _layout["default"].GRID:
        return (0, _gridGallery.createStyles)(styles);

      case _layout["default"].THUMBNAIL:
        return (0, _thumbnailGallery.createStyles)(styles);

      case _layout["default"].SLIDER:
        return (0, _sliderGallery.createStyles)(styles);

      case _layout["default"].SLIDESHOW:
        return (0, _slideshowGallery.createStyles)(styles);

      case _layout["default"].PANORAMA:
        return (0, _panoramaGallery.createStyles)(styles);

      case _layout["default"].COLUMN:
        return (0, _columnGallery.createStyles)(styles);

      case _layout["default"].MAGIC:
        return (0, _magicGallery.createStyles)(styles);

      case _layout["default"].FULLSIZE:
        return (0, _fullsizeGallery.createStyles)(styles);

      case _layout["default"].BRICKS:
        return (0, _bricksGallery.createStyles)(styles);

      case _layout["default"].MIX:
        return (0, _mixGallery.createStyles)(styles);

      case _layout["default"].ALTERNATE:
        return (0, _alternateGallery.createStyles)(styles);

      case _layout["default"].EMPTY:
        return (0, _emptyGallery.createStyles)(styles);

      case _layout["default"].COLLAGE:
      default:
        return (0, _collageGallery.createStyles)(styles);
    }
  }
};

exports.addPresetStyles = addPresetStyles;
var _default = {
  alternate: _alternateGallery.fixedStyles,
  bricks: _bricksGallery.fixedStyles,
  collage: _collageGallery.fixedStyles,
  fullsize: _fullsizeGallery.fixedStyles,
  column: _columnGallery.fixedStyles,
  grid: _gridGallery.fixedStyles,
  magic: _magicGallery.fixedStyles,
  masonry: _masonryGallery.fixedStyles,
  mix: _mixGallery.fixedStyles,
  panorama: _panoramaGallery.fixedStyles,
  slider: _sliderGallery.fixedStyles,
  slideshow: _slideshowGallery.fixedStyles,
  thumbnails: _thumbnailGallery.fixedStyles,
  empty: _emptyGallery.fixedStyles
};
exports["default"] = _default;